// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"traffic-events"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M18.2969 19.5156L12 4.5L5.70312 19.5156H18.2969Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.5 10.5H9.5L7.5 15.2308H16.5L14.5 10.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 20H20M8 15.2305H16M10 10.5H14M18.2969 19.5156L12 4.5L5.70313 19.5156","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TrafficEventsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'traffic-events',
    ref,
    icon: element,
  },
));

TrafficEventsIcon.displayName = 'TrafficEventsIcon';

export default TrafficEventsIcon;
